import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-variant-secondary-price',
  templateUrl: './header-column-variant-secondary-price.component.html',
  styleUrls: ['./header-column-variant-secondary-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnVariantSecondaryPriceComponent extends HeaderColumnComponent {}
